import React from 'react';
import './MainContent.css';

const PageContent = ({ ...children }) => (
  <main className="main-base-content">{children.children}</main>
);

export default PageContent;
